import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import PerformanceStore from "../../store/PerformanceStore";

const PerformanceModuleWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/performance")
      navigate("/performance/overall performance");
    return () => {
      PerformanceStore.setData("fromDatePerf", null);
      PerformanceStore.setData("toDatePerf", null);
      PerformanceStore.setData("lastTabName", "CUSTOM");
      PerformanceStore.setDuration("ITD");
      PerformanceStore.setSecPageDuration("");
      PerformanceStore.setData("persistedSecPageDuration", "");
      PerformanceStore.setData("eventsData", []);
      PerformanceStore.setData("selectedEvent", {
        eventName: "Event not selected",
        id: null,
      });
      PerformanceStore.setData("selectedAssetClass", {
        id: "all",
        name: "Overall",
      });
      PerformanceStore.setData("nonDerivativeCheckedStatus", true);
    };
  }, []);
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PerformanceModuleWrapper;
